import { createFileRoute } from "@tanstack/react-router";

import { RoutePage, routeEntry } from "./routeTable";

const entry = routeEntry("/reports/lane-days-drift");

export const Route = createFileRoute("/reports/lane-days-drift")({
  head: () => ({
    meta: [
      { title: "Lane-days drift report — LevelLoad" },
      { name: "description", content: "Lane-days drift report — LevelLoad transport planning." },
      { property: "og:title", content: "Lane-days drift report — LevelLoad" },
      {
        property: "og:description",
        content: "Lane-days drift report — LevelLoad transport planning.",
      },
      { property: "og:type", content: "website" },
      { name: "twitter:card", content: "summary_large_image" },
    ],
  }),
  component: RouteComponent,
});

function RouteComponent() {
  return <RoutePage entry={entry} />;
}
